import _ from "lodash";

import { AvailablePopulateUsecase } from "../../../usecases";
import { DepartmentESocialCopiesService } from "../DepartmentESocialCopiesService/DepartmentESocialCopiesService";
import { DepartmentPersonnelCopiesService } from "../DepartmentPersonnelCopiesService/DepartmentPersonnelCopiesService";
import { DepartmentTaxCopiesService } from "../DepartmentTaxCopiesService/DepartmentTaxCopiesService";

export class DepartmentCopiesSyncService {
    constructor({
        PointHttpGateway,
        SerieHttpGateway,
        AvailableHttpGateway,
        CompanyHttpGateway,
        PopulateManager,
        PointCalculated
    }) {
        this.PointHttpGateway = PointHttpGateway;
        this.SerieHttpGateway = SerieHttpGateway;
        this.AvailableHttpGateway = AvailableHttpGateway;
        this.CompanyHttpGateway = CompanyHttpGateway;
        this.PopulateManager = PopulateManager;
        this.PointCalculated = PointCalculated;

        this.DepartmentPersonnelCopiesService = new DepartmentPersonnelCopiesService(
            {
                SerieHttpGateway,
                AvailableHttpGateway,
                CompanyHttpGateway
            }
        );

        this.DepartmentESocialCopiesService = new DepartmentESocialCopiesService(
            {
                SerieHttpGateway,
                AvailableHttpGateway,
                CompanyHttpGateway
            }
        );

        this.DepartmentTaxCopiesService = new DepartmentTaxCopiesService({
            SerieHttpGateway,
            AvailableHttpGateway,
            CompanyHttpGateway
        });
    }

    async syncToPersonnel({ company, from }) {
        this.DepartmentPersonnelCopiesService.setCompany({ company });
        const copiesConfigs = this.DepartmentPersonnelCopiesService.getCopiesConfigs(
            { scenarioId: "ORIGINAL", series: [] }
        );

        const copy = copiesConfigs.find((copy) => copy.from === from);

        if (_.get(company, `props.${copy.preference}`))
            return await this.DepartmentPersonnelCopiesService.syncCopy({
                from
            });

        return false;
    }

    async syncToESocial({ company, from }) {
        this.DepartmentESocialCopiesService.setCompany({ company });
        const copiesConfigs = this.DepartmentESocialCopiesService.getCopiesConfigs(
            { scenarioId: "ORIGINAL", series: [] }
        );
        const copy = copiesConfigs.find((copy) => copy.from === from);
        if (_.get(company, `props.${copy.preference}`)) {
            return await this.DepartmentESocialCopiesService.syncCopy({
                from
            });
        }
        return false;
    }

    async syncToTax({ company, from }) {
        this.DepartmentTaxCopiesService.setCompany({ company });
        const copiesConfigs = this.DepartmentTaxCopiesService.getCopiesConfigs({
            scenarioId: "ORIGINAL",
            series: []
        });
        const copy = copiesConfigs.find((copy) => copy.from === from);
        if (_.get(company, `props.${copy.preference}`)) {
            await this.DepartmentTaxCopiesService.syncCopy({
                from
            });
            return true;
        }
        return false;
    }

    async clearCollections({ company }) {
        this.PopulateManager.deleteMany({
            collections: { $in: ["points", "series"] }
        });
        this.PointHttpGateway.deleteMany({});
        if (this.PointCalculated) this.PointCalculated.deleteMany({});
        const availablePopulateUsecase = new AvailablePopulateUsecase();
        await availablePopulateUsecase.execute({
            companyId: company.props._id
        });
    }

    async syncsFromTax({ company }) {
        await Promise.all([
            this.syncToPersonnel({ company, from: "tax" }),
            this.syncToESocial({ company, from: "tax" })
        ]);

        this.clearCollections({ company });

        return true;
    }

    async syncsFromPGDAS({ company }) {
        await Promise.all([
            this.syncToPersonnel({ company, from: "simplesNacional" }),
            this.syncToESocial({ company, from: "simplesNacional" })
        ]);

        const hasSyncWithPGDAS = await this.syncToTax({
            company,
            from: "simplesNacional"
        });

        if (hasSyncWithPGDAS) {
            await Promise.all([
                this.syncToESocial({ company, from: "tax" }),
                this.syncToPersonnel({ company, from: "tax" })
            ]);
        }

        this.clearCollections({ company });

        return true;
    }

    async syncsFromAccounting({ company, clearCollections = true }) {
        const hasSyncWithTax = await this.syncToTax({
            company,
            from: "accounting"
        });

        await Promise.all([
            this.syncToPersonnel({ company, from: "accounting" }),
            this.syncToESocial({ company, from: "accounting" })
        ]);

        if (hasSyncWithTax) {
            await Promise.all([
                this.syncToPersonnel({ company, from: "tax" }),
                this.syncToESocial({ company, from: "tax" })
            ]);
        }

        if (clearCollections) this.clearCollections({ company });
    }
}
